export const data: {
  category: string;
  tags: string[];
  manifestos: {
    title: string,
    contents: string[],
  }[]
}[] = [
  {
    category: '친절한 성남',
    tags: [
      "15분버스", "판교주3일출근제", "창업가의마을", "테크인턴십"
    ],
    manifestos: [
      {
        title: '우리동네 정책비서 신설 운영',
        contents: [
          '성남시내 모든 동주민센터에 맞춤형 정책 안내, 해설 전담 부서 ‘우리동네 정책비서’ 설치',
          '이해하기 어려운 각종 공공 정책, 제도를 쉽게 풀이',
          '몰라서 이용하지 못했던 정책을 안내하고 지원 연계',
        ]
      },
      {
        title: '공공편의시설 ‘성남스테이’ 전지역 설치 및 운영',
        contents: [
          '성남시 내 각종 공공기관 유휴공간(1층 로비 등)을 시민 휴식 공간으로 개방',
          '시민들이 어디서나 환대 받으며 무료로 자유롭게 이용할 수 있는 다양한 공공편의시설 (어린이미술관, 도서관, 북카페, 체험존 등) ‘성남스테이’ 전지역 설치 및 운영',
          '초등학교 주변 편의점과 협의해 아이들이 편히 머물 수 있도록 ‘편의점 성남 스테이’ 추진'
        ]
      },
      {
        title: '성남 시소 위크(시민 소모임 홍보 주간) 운영',
        contents: [
          '성남시의 다양한 소모임 활동을 홍보하고, 전 세대들이 함께 연결될 수 있는 소모임 교류의 장 개최',
          '세대 간, 지역 간 소모임 운영 활성화 지원',
        ]
      },
      {
        title: '경사로 및 리프트 설치 지원사업',
        contents: [
            '이동약자의 편리한 이동을 위해 재임기간 중 1,400개의 경사로 설치',
            '엘리베이터 없는 노후 건물 리프트 설치 비용 지원 사업 실시',
        ]
      },
      {
        title: '장애인 콜택시 시스템 효율화',
        contents: [
          '주요 택시 앱에서 장애인택시바우처 이용할 수 있도록 연계',
          '택시 사업자의 장애인 탑승 차량 개조 비용 지원 사업',
        ]
      },
      {
        title: '어르신 동행 바우처 지원',
        contents: [
          '홀몸 어르신이 동행/활동보조 서비스를 무료로 이용할 수 있는 바우처 제공'
        ]
      }
    ],
  },
  {
    category: '여유로운 성남',
    tags: [
      "정책비서", "공공편의시설", "어르신동행바우처", "장애인콜택시"
    ],
    manifestos: [
      {
        title: '서현동 110번지, ‘젊은 도시’의 출발점으로',
        contents: [
          '서현동 110번지 공공주택지구 사업 재추진',
          '갈등조정위원회 설치해 의견 수렴, 중재하고 교통, 학교, 생태보전 대안 실행',
          '청년, 무주택자, 신혼부부 주거 지원 중심으로 공급 추진',
        ]
      },
      {
        title: '모두의 권리를 보호하는 합리적 재개발로의 전환',
        contents: [
          '용적률, 안전진단기준 완화를 통해 주택 공급 확대 추진',
          '이주 대상 세입자들을 위한 맞춤형 상담기관 한시적 운영',
          '재개발 시 의무 임대주택 건립비율 상향조정',
          '동계철거 금지조례 도입',
        ]
      },
      {
        title: '성남시 내부 교통망 효율화: “15분 버스 도시”',
        contents: [
          '취임과 동시에 15분 버스 TF팀 설치',
'성남 시내버스 배차간격 최소화 (최장 대기시간 15분 내외)',
'성남 시내 순환 버스 노선 재정비, 마을버스 노선 다양화',
'3호선 & 8호선 연장 사업 적극 추진 및 진행 상황 알림 서비스 시행',
'판교~분당 연결 트램',
        ]
      },
      {
        title: '분당/수정/중원 산책 인프라 상향평준화',
        contents: [
          '성남시내 산책 격차 해소: 수정/중원지역 공원, 산책로 조성',
'장애물 없는 산책 환경 조성 사업',
'수요조사 기반 생활체육시설 건립',
'반려견 운동장이 부족한 지역에 신규 설치',
        ]
      },
      {
        title: '‘원격근무의 성지 판교’ 프로젝트 추진',
        contents: [
          '3일 출근, 2일 원격 근무를 보장하기 위한 실태조사, 사회적 협약 추진',
'원격근무 협약 참여 기업 인센티브 제공 (비수도권 워케이션 장소 제공 등)',
        ]
      },
      {
        title: '판교 테크노벨리 ‘창업가의 마을’ 커뮤니티 조성',
        contents: [
          '판교 테크노벨리의 청년 주거 문제에 대응함과 동시에 탁월한 스타트업이 탄생할 수 있도록 교류와 시너지를 촉진하는 물리적 커뮤니티 조성',
        ]
      },
      {
        title: '성남 어린이/청소년 4차산업 인턴십 프로그램 시행',
        contents: [
          '성남시 어린이/청소년들을 대상으로 판교 내 IT 기업들과 연계한 멘토링, 커리어 체험, 네트워킹 지원',
'학교 클럽활동/동아리활동 시간과 연계',
        ]
      },
      {
        title: '레트로 태평 프로젝트',
        contents: [
          '태평동을 중심으로 레트로 트렌드에 맞춘 골목형 상점가 육성, 특화거리 활성화, 마케팅 지원, 판로개척 지원 등 재정비 & 리브랜딩 사업 진행'
        ]
      }
    ]
  },
  {
    category: '안전한 성남',
    tags: [
      "직장내괴롭힘", "피해자조력활동가", "참여형지도", "깨끗한우리동네"
    ],
    manifestos: [
      {
        title: '수요자 중심의 안전 귀갓길 조성 지원 사업',
        contents: [
          '귀갓길 위험 정보, 안전 문제를 위치 기반으로 쉽게 제보하는 웹서비스 운영',
'수요 데이터에 따른 귀갓길 안전등 (가로등, 바닥 LED) 설치 지원 사업 시행',
        ]
      },
      {
        title: '직장내 괴롭힘 피해자 조력활동가 양성 사업',
        contents: [
          '괴롭힘 피해를 입는 직장 동료를 돕는 방법 배우는 시민 교육 과정 운영',
'많은 성남시민이 이수하도록 해서 괴롭힘에 대한 사회적 안전망 만들기',
        ]
      },
      {
        title: '1인가구 고독사 방지 위한 데이터 기반 안전망 구축',
        contents: [
          '생활 편의 IT 서비스 관련 기업과 연계해 고독사 위험군 탐지 시스템 개발',
'기존 공공 데이터만으로 탐지되지 않는 위험군 찾기, 지원 연계',
        ]
      },
      {
        title: '재개발 현장 안전 설비 지원',
        contents: [
          '재개발 현장 산재 사고를 줄이기 위해 양질의 안전 설비 설치 비용 지원',
        ]
      }
    ]
  }
]